import { render, staticRenderFns } from "./SkuGrowthChart.vue?vue&type=template&id=967387f8&"
import script from "./SkuGrowthChart.vue?vue&type=script&lang=js&"
export * from "./SkuGrowthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports